export default function SupportPage() {
  return (
    <div style={{ fontFamily: 'Inter, sans-serif', minHeight: '100vh', background: '#fafaf8', color: '#1a1a2e' }}>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        a { color: #5c4d96; text-decoration: none; }
        a:hover { text-decoration: underline; }
      `}</style>

      <nav style={{
        position: 'sticky', top: 0, padding: '20px 32px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        background: 'rgba(250,250,248,0.9)', backdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(0,0,0,0.06)', zIndex: 100,
      }}>
        <a href="/" style={{ fontWeight: 800, fontSize: 22, color: '#5c4d96' }}>AirScribe</a>
      </nav>

      <div style={{ maxWidth: 640, margin: '0 auto', padding: '72px 24px 96px' }}>
        <span style={{
          display: 'inline-block', background: 'rgba(92,77,150,0.1)', color: '#5c4d96',
          fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase',
          padding: '5px 14px', borderRadius: 20, marginBottom: 16,
        }}>Support</span>

        <h1 style={{ fontSize: 'clamp(32px, 5vw, 48px)', fontWeight: 800, lineHeight: 1.1, marginBottom: 16 }}>
          We're here to help.
        </h1>
        <p style={{ fontSize: 17, color: '#666', lineHeight: 1.7, marginBottom: 48 }}>
          Have a question, found a bug, or need help with AirScribe? Reach out and we'll get back to you within one business day.
        </p>

        <div style={{
          background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.8)', borderRadius: 20,
          padding: '32px', boxShadow: '0 4px 24px rgba(0,0,0,0.05)', marginBottom: 24,
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 8 }}>Email</div>
          <a href="mailto:support@airscribe.app" style={{ fontSize: 20, fontWeight: 600, color: '#5c4d96' }}>
            support@airscribe.app
          </a>
          <p style={{ marginTop: 8, fontSize: 14, color: '#888', lineHeight: 1.6 }}>
            For billing, account issues, bug reports, and general questions.
          </p>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.8)', borderRadius: 20,
          padding: '32px', boxShadow: '0 4px 24px rgba(0,0,0,0.05)',
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 8 }}>FAQ</div>
          <p style={{ fontSize: 15, color: '#555', lineHeight: 1.7, marginBottom: 16 }}>
            Find answers to common questions about AirScribe.
          </p>
          <a href="/#faq" style={{
            display: 'inline-block', background: 'rgba(92,77,150,0.1)', color: '#5c4d96',
            padding: '10px 22px', borderRadius: 12, fontWeight: 600, fontSize: 14,
          }}>
            View FAQ →
          </a>
        </div>
      </div>

      <footer style={{
        textAlign: 'center', padding: 28, fontSize: 13, color: '#888', opacity: 0.7,
        borderTop: '1px solid rgba(0,0,0,0.06)',
      }}>
        © 2026 AirScribe. All rights reserved.
      </footer>
    </div>
  );
}
